import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { showImageModal } from '../../actions/image';

import './AttireThumbnail.css';


class AttireThumbnail extends React.Component {
  static propTypes = {
    image: PropTypes.string.isRequired,

    // Redux Dispatch.
    showImageModal: PropTypes.func.isRequired,
  };

  onClick = (e) => {
    e.preventDefault();
    this.props.showImageModal(this.props.image);
  };

  render() {
    const { image } = this.props;
    return (
      <button className="thumbnail attire-thumbnail" href="#" onClick={this.onClick}>
        <img alt="" src={image} />
      </button>
    );
  }
}

const mapDispatchToProps = {
  showImageModal,
};

export default connect(null, mapDispatchToProps)(AttireThumbnail);



// WEBPACK FOOTER //
// ./src/components/RemindersPage/AttireThumbnail.js